import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { getDataAttributes } from '../../util/getDataAttributes/getDataAttributes.js';
import { Box } from '../Box/Box.js';
import { Icon } from '../Icon/Icon.js';
import { TextLink } from '../TextLink/TextLink.js';

var _excluded = ["contents", "maxItems", "withMeta"],
  _excluded2 = ["content", "link", "aria-current"];
var DEFAULT_MAX_ITEMS = 5;
var TRUNCATED_CONTENT = '...';
var getItems = function getItems(contents, maxItems) {
  if (maxItems) {
    var totalMaxItems = Math.min(maxItems || DEFAULT_MAX_ITEMS, contents.length) - 1; // excluded '...'
    var items = contents.slice(contents.length - totalMaxItems, contents.length); // Keep only last {maxItems} items when truncated
    items.unshift({
      content: TRUNCATED_CONTENT,
      link: ''
    });
    return items;
  }
  return contents;
};
var Breadcrumb = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var contents = _ref.contents,
    maxItems = _ref.maxItems,
    withMeta = _ref.withMeta,
    rest = _objectWithoutProperties(_ref, _excluded);
  var icon = React.useMemo(function () {
    return /*#__PURE__*/React.createElement(Icon, {
      id: "fill.arrow.thin-forward",
      color: "base.subtle",
      size: "12",
      mx: "4"
    });
  }, []);
  if (!(contents !== null && contents !== void 0 && contents.length)) return null;
  var items = getItems(contents, maxItems);
  var breadcrumbs = items.map(function (item, index) {
    var content = item.content,
      link = item.link,
      ariaCurrent = item['aria-current'],
      args = _objectWithoutProperties(item, _excluded2);
    var isLastItem = index === items.length - 1;
    var _getDataAttributes = getDataAttributes(args),
      dataAttributes = _getDataAttributes.dataAttributes;
    if (!link && content !== TRUNCATED_CONTENT) {
      return null;
    }
    var ariaCurrentValue = isLastItem ? ariaCurrent || 'page' : undefined;
    return /*#__PURE__*/React.createElement(Box, _extends({}, args, {
      key: content,
      display: "flex",
      alignItems: "center",
      mb: "4"
    }, dataAttributes), /*#__PURE__*/React.createElement(TextLink, {
      label: content,
      href: link,
      textVariant: "body-s",
      hierarchy: "tertiary",
      rel: "noopener",
      "aria-current": ariaCurrentValue
    }), withMeta && /*#__PURE__*/React.createElement("meta", {
      itemProp: "position",
      content: (index + 1).toString()
    }), index !== items.length - 1 && icon);
  }).filter(Boolean);
  return /*#__PURE__*/React.createElement(Box, _extends({}, rest, {
    ref: ref,
    as: "nav",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    "aria-label": rest['aria-label'] || 'Breadcrumb'
  }), breadcrumbs);
});
var BreadcrumbMemoized = /*#__PURE__*/React.memo(Breadcrumb);
BreadcrumbMemoized.displayName = 'Breadcrumb';

export { BreadcrumbMemoized as Breadcrumb };
//# sourceMappingURL=Breadcrumb.js.map
